import { render, staticRenderFns } from "./SpaceSelector.vue?vue&type=template&id=585a90d7&"
import script from "./SpaceSelector.vue?vue&type=script&lang=js&"
export * from "./SpaceSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports